import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import "@wedraft/editor-ui/styles.css";
import "./styles.css";
import "./design-system.css";
ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><App /></React.StrictMode>);
